<div class="memories">
  <div class="memories__setting">
    <div class="memories__setting-text">
      <span class="memories__setting-title">Memória automática</span>
      <span class="memories__setting-desc">
        A AyA cria memórias sozinha a partir das suas conversas
      </span>
    </div>
    <sgt-switch-input
      [ngModel]="automaticCaptureEnabled"
      [disabled]="isSavingSettings"
      (ngModelChange)="toggleAutomaticMemory($event)"
    ></sgt-switch-input>
  </div>

  <div class="memories__new">
    <input
      type="text"
      class="memories__input memories__input--new"
      [formControl]="newMemoryControl"
      [maxlength]="maxLength"
      placeholder="Nova memória…"
      (keydown.enter)="create()"
    />
    <button
      type="button"
      class="btn btn-primary memories__add"
      [disabled]="isCreating || newMemoryControl.invalid"
      (click)="create()"
    >
      <i
        class="fas"
        [class.fa-plus]="!isCreating"
        [class.fa-spinner]="isCreating"
        [class.fa-spin]="isCreating"
        aria-hidden="true"
      ></i>
      {{ isCreating ? 'Adicionando…' : 'Adicionar memória' }}
    </button>
  </div>

  <div class="memories__list" *ngIf="isLoading">
    <span class="memories__skeleton" *ngFor="let i of skeletonRows"></span>
  </div>

  <p class="memories__feedback" *ngIf="!isLoading && hasError">
    Não foi possível carregar suas memórias. Tente novamente em instantes.
  </p>

  <p class="memories__feedback" *ngIf="!isLoading && !hasError && !rows.length">
    A AyA ainda não guarda nenhuma memória sua. Adicione a primeira acima.
  </p>

  <ng-container *ngIf="!isLoading && !hasError && rows.length">
    <div class="memories__list">
      <div class="memories__row" *ngFor="let row of rows; trackBy: trackByMemoryId">
        <i class="fas fa-circle-check memories__row-icon"></i>
        <span class="memories__content">{{ row.memory.content }}</span>

        <sgt-confirm-popover
          variant="danger"
          message="Remover esta memória?"
          confirmLabel="Remover"
          cancelLabel="Cancelar"
          position="bottom"
          (confirmed)="remove(row)"
        >
          <button
            type="button"
            class="memories__remove"
            [disabled]="row.isRemoving"
          >
            <i
              class="fas"
              [class.fa-times]="!row.isRemoving"
              [class.fa-spinner]="row.isRemoving"
              [class.fa-spin]="row.isRemoving"
            ></i>
          </button>
        </sgt-confirm-popover>
      </div>
    </div>

    <p class="memories__more" *ngIf="hasMore">
      Mostrando as memórias mais recentes.
    </p>
  </ng-container>
</div>
